module.exports = __webpack_public_path__ + "img/email.09de2fa7.svg";